/**
 * Overlay for the generated client so local Umbraco works without hand-editing `src/generated`.
 * When `CMS_DELIVERY_API_BASE_URL` is set, `OpenAPI.BASE` reads that origin (call-site assignments
 * cannot override it). Gateway path stripping happens in `getUrl` via `fix-generated-types.js`.
 *
 * See README.md in this package.
 */
import { OpenAPI } from '../generated/core/OpenAPI';
import { getContentDeliveryBaseUrl } from './content-delivery-base-url';

let installed = false;
let baseOverride = '';

const installOpenApiBase = () => {
  Object.defineProperty(OpenAPI, 'BASE', {
    configurable: true,
    enumerable: true,
    get: () => getContentDeliveryBaseUrl() || baseOverride,
    set: (value: string) => {
      baseOverride = value ?? '';
    },
  });
};

/**
 * Point the generated client at `CMS_DELIVERY_API_BASE_URL` when set.
 * Safe to call more than once.
 */
export const installContentDeliveryClient = (): void => {
  if (installed) return;

  installed = true;
  installOpenApiBase();
};

/** @deprecated Importing the package already installs the client. Kept for existing call sites. */
export const applyContentDeliveryOpenAPI = (): void => {
  installContentDeliveryClient();
};
